import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { forumTypes, forumTypesIconMap } from '@/app/models/forum/forum-types.config'
import { ForumTypeEnum } from '@/app/models/forum/new-forum.model'
import TypeList, { Type } from '../UI/TypeList/TypeList'

export interface ForumTypeListProps {
    onChangeType: (key: ForumTypeEnum) => void
    activeType: ForumTypeEnum
}

const ForumTypeList = ({ onChangeType, activeType }: ForumTypeListProps) => {
    const intl = useIntl()

    const title = useMemo<string>(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.discussion.type',
                defaultMessage: 'Discussion type',
            }),
        [intl]
    )

    const typeList = useMemo<Type[]>(() => {
        return forumTypes.filterForumTypes.map((type) => ({
            key: type.forumTypeName,
            icon: forumTypesIconMap[type.forumTypeName],
            active: type.forumTypeName === activeType,
            label: intl.formatMessage({
                id: `modals.new.forum.discussion.type.${type.forumTypeName}`,
                defaultMessage: type.forumTypeName,
            }),
        }))
    }, [forumTypes, activeType])

    return <TypeList title={title} typeList={typeList} onClick={onChangeType} />
}

export default ForumTypeList
